import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Breadcrumbs as MuiBreadcrumbs, Link, Typography } from "@material-ui/core";
import { NavigateNext, Home } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  link: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
}));

const Breadcrumbs = ({ items = [] }) => {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = (path) => {
    if (path) {
      history.push(path);
    }
  };

  return (
    <MuiBreadcrumbs
      separator={<NavigateNext fontSize="small" />}
      className={classes.root}
    >
      <Link
        color="inherit"
        onClick={() => handleClick("/help")}
        className={classes.link}
      >
        <Home className={classes.icon} />
        Central de Ajuda
      </Link>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return isLast ? (
          <Typography color="textPrimary" key={index}>
            {item.label}
          </Typography>
        ) : (
          <Link
            color="inherit"
            onClick={() => handleClick(item.path)}
            className={classes.link}
            key={index}
          >
            {item.label}
          </Link>
        );
      })}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;
